import { Box, Paper, useTheme } from '@mui/material';
import IncentivioLogo2 from 'components/incentivio-logo/incentivio-logo-2.component';
import { ReactNode } from 'react';

type LoginLayoutType = {
  children: ReactNode;
};

const LoginLayout = ({ children }: LoginLayoutType) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Paper
      sx={{
        p: 2,
        pt: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 450,
      }}
      data-testid="LoginPage.Paper"
    >
      <Box maxWidth={300}>
        <IncentivioLogo2
          color={isDarkMode ? theme.palette.common.white : undefined}
        />
      </Box>
      {children}
    </Paper>
  );
};

export default LoginLayout;
